module.exports = __webpack_public_path__ + "static/media/4.554119f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/vitebsk/4.jpg
// module id = 251
// module chunks = 0